export const GHL_SEND_TIMEOUT_MS = 12000;

/** Outbound webhook identifier sent to GHL inbound hooks (not user-visible). */
export const GHL_WEBHOOK_USER_AGENT = "TurboAssist/1.0";

export async function ghlFetchWithTimeout(url: string, init: RequestInit, timeoutMs: number): Promise<Response> {
  const controller = new AbortController();
  const t = window.setTimeout(() => controller.abort(), timeoutMs);

  try {
    return await fetch(url, { ...init, signal: controller.signal });
  } finally {
    window.clearTimeout(t);
  }
}
